export const NOTIFICATION_DATA = [
	{
		title: "New sales order received",
		status: "unread",
		id: "#204",
		time: "10 minutes ago",
		icon: "paid",
		color: "bg-red-400",
	},
	{
		title: "New user account registered",
		status: "unread",
		id: "#3102",
		time: "23 minutes ago",
		icon: "account_circle",
		color: "bg-green-400",
	},
	{
		title: "New product review received",
		status: "unread",
		id: "#8973",
		time: "48 minutes ago",
		icon: "contact_support",
		color: "bg-blue-400",
	},
	{
		title: "New product review received",
		status: "unread",
		id: "#8972",
		time: "50 minutes ago",
		icon: "contact_support",
		color: "bg-cyan-400",
	},
	{
		title: "New sales order received",
		status: "unread",
		id: "#203",
		time: "55 minutes ago",
		icon: "paid",
		color: "bg-fuchsia-400",
	},
	{
		title: "Review unpaid orders",
		status: "read",
		id: "#765",
		time: "2 hours ago",
		icon: "visibility",
		color: "bg-amber-400",
	},
	{
		title: "New issue filed by customer",
		status: "unread",
		id: "#721",
		time: "2 hours ago",
		icon: "bug_report",
		color: "bg-sky-400",
	},
	{
		title: "New comment received",
		status: "read",
		id: "#976",
		time: "3 hours ago",
		icon: "chat",
		color: "bg-lime-400",
	},
	{
		title: "Thread responded and closed",
		status: "unread",
		id: "#45",
		time: "5 hours ago",
		icon: "task_alt",
		color: "bg-orange-400",
	},
	{
		title: "Thread re-opened by administrator",
		status: "read",
		id: "#8972",
		time: "6 hours ago",
		icon: "markunread_mailbox",
		color: "bg-purple-400",
	},
	{
		title: "New support request received",
		status: "read",
		id: "#432",
		time: "8 hours ago",
		icon: "help_outline",
		color: "bg-rose-400",
	},
	{
		title: "New issue filed by customer",
		status: "read",
		id: "#720",
		time: "2 days ago",
		icon: "bug_report",
		color: "bg-violet-400",
	},
];
